import Team from 'domains/models/team';
import { formatToISO } from 'infras/datetime';

import { z } from 'zod';
import { ProviderTypeEnum } from '../account/enum';
import { CancelReasonTypeEnum } from '../subscription_cancel_reason/enum';

export type TeamCreateBody = z.infer<typeof schemaTeamCreateBody>;
export const schemaTeamCreateBody = z.object({
  name: z.string().nullable().optional(),
  providerType: ProviderTypeEnum.nullable().optional(),
});

export type TeamJoinBody = z.infer<typeof schemaTeamJoinBody>;
export const schemaTeamJoinBody = z.object({
  providerType: z.number().optional(),
});

export type TeamUpdateBody = z.infer<typeof schemaTeamUpdateBody>;
export const schemaTeamUpdateBody = z.object({
  name: z.string().optional(),
  profile: z.string().nullable().optional(),
  slug: z.string().optional(),
  profileImage: z.string().optional(),
  referralCode: z.string().nullable().optional(),
});

export type TeamDeleteBody = z.infer<typeof schemaTeamDeleteBody>;
export const schemaTeamDeleteBody = z.object({
  reason: z.string().nullable().optional(),
  reasonType: z.number().nullable().optional(),
  cancelReason: z
    .object({
      feedback: z.string(),
      reasons: z.array(
        z.object({
          reason: CancelReasonTypeEnum,
          detail: z.string().optional(),
        }),
      ),
    })
    .nullable()
    .optional(),
});

export type TeamListItem = z.infer<typeof schemaTeamListItem>;
export const schemaTeamListItem = z.object({
  id: z.number(),
  uid: z.string(),
  slug: z.string(),
  profile: z.string().nullable(),
  name: z.string().nullable(),
  profileImage: z.string().nullable(),
});

export type TeamItem = z.infer<typeof schemaTeamItem>;
export const schemaTeamItem = z.object({
  id: z.number(),
  uid: z.string(),
  slug: z.string(),
  profile: z.string().nullable(),
  name: z.string().nullable(),
  profileImage: z.string().nullable(),
  headerTeamImage: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type TeamDetailItem = z.infer<typeof schemaTeamDetailItem>;
export const schemaTeamDetailItem = schemaTeamItem.extend({
  referralCode: z.string().nullable(),
});

export const toListItem = (team: Team): TeamListItem => {
  return {
    id: Number(team.id),
    uid: team.uid,
    slug: team.slug,
    name: team.name,
    profile: team.profile,
    profileImage: team.profileImage,
  };
};

export const toItem = (team: Team): TeamItem => {
  return {
    id: Number(team.id),
    uid: team.uid,
    slug: team.slug,
    name: team.name,
    profile: team.profile,
    profileImage: team.profileImage,
    headerTeamImage: team.headerTeamImage,
    createdAt: formatToISO(team.createdAt),
    updatedAt: formatToISO(team.updatedAt),
  };
};
